import { render, staticRenderFns } from "./Radio.vue?vue&type=template&id=a30e141a"
import script from "./Radio.vue?vue&type=script&lang=ts"
export * from "./Radio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports